export default "__VITE_ASSET__09b1cc0a__"